import http from "../services/http";

export const apiGetAppointments = async (params = {}) => {
  try {
    const response = await http.get("/api/doctor/appointments/upcoming", {
      params,
    });
    return response;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const apiGetAppointmentDetails = async (appointmentId) => {
  try {
    const response = await http.get(
      `/api/doctor/appointments/details?appointmentId=${appointmentId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching appointment details:", error);
    throw error;
  }
};

export const apiCancelAppointment = async (appointmentId) => {
  try {
    const response = await http.post(
      `/api/patient/appointment/cancel`,
      { appointmentId }
    );
    return response.data;
  } catch (error) {
    console.error("Error cancelling appointment:", error);
    throw error;
  }
};

export const apiRescheduleAppointment = async (appointmentId, scheduleData) => {
  try {
    const response = await http.post(
      `/api/doctor/appointments/${appointmentId}/reschedule`,
      scheduleData
    );
    return response.data;
  } catch (error) {
    console.error("Error rescheduling appointment:", error);
    throw error;
  }
};

export const apiCheckAvailableSlots = async (params) => {
  try {
    const response = await http.post(`/api/doctor/check-slots`, params);
    return response.data;
  } catch (error) {
    console.error("Error checking available slots:", error);
    throw error;
  }
};

export const apiUpdateConsultationNote = async (payload) => {
  try {
    const response = await http.post("/api/doctor/appointments/notes", {
      ...payload,
    });
    return response;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};
